import React, { createContext, useContext, useState } from 'react';

const ModalSystemContext = createContext();

export const ModalSystemProvider = ({ children }) => {
  const [modalType, setModalType] = useState(null);
  const [modalProps, setModalProps] = useState({});

  const openModal = (type, props = {}) => {
    setModalType(type);
    setModalProps(props);
  };

  const hideModal = () => {
    setModalType(null);
    setModalProps({});
  };

  return (
    <ModalSystemContext.Provider value={{ modalType, modalProps, openModal, hideModal }}>
      {children}
    </ModalSystemContext.Provider>
  );
};

export const useModalSystem = () => {
  const context = useContext(ModalSystemContext);
  if (!context) throw new Error('useModalSystem must be used within ModalSystemProvider');
  return context;
};
